export default abstract class ChatMentionTarget<ID = any> {
  id!: ID;
  name = '';
  description = '';

  abstract get typeName(): string;
}